import React, { useEffect } from "react";
import StandardTemplate from "../../../templates/standard_template/standard_template";
import CreditAuth from "../../../components/loan_tools/forms/credit_auth";
import FormEmailButton from "../../../components/loan_tools/forms/form_email_button";
import { useDocument } from "../../../components/loan_tools/loan_tool";

export default function CreditAuthRoute() {
  const [loanDoc, , , actions] = useDocument();

  useEffect(() => {
    const borrowers = loanDoc && loanDoc.applicant && loanDoc.applicant.borrowers;
    const lastName = (borrowers && borrowers[0] && borrowers[0].last_name) || "";
    const title = lastName ? `${lastName} – Credit Auth` : "Credit Auth";
    actions.setPageTitleOverride(title);
    return () => actions.setPageTitleOverride(null);
  }, [loanDoc]);

  return (
    <StandardTemplate className="ba-template">
      <div className="ba-page-actions no-print">
        <button className="button" onClick={() => window.print()}>Save / Print PDF</button>
        <FormEmailButton docName="Credit Authorization" />
      </div>
      <CreditAuth />
    </StandardTemplate>
  );
}
